import styled from 'react-emotion'
import { css, cx } from 'emotion'
import { themeGet as th } from 'styled-system'
import { Flex, Box } from 'shared/ui'
import { labelObjFor } from 'util/recipientLabel'

const truncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Recipient = ({ className, recipient }) => {
  if (!recipient) return null
  const { name, email } = labelObjFor(recipient)

  return (
    <Flex className={className}>
      <Box className={cx(truncate, 'name')}>{name}</Box>
      {email && <Box className={cx(truncate, 'email')}>{`<${email}>`}</Box>}
    </Flex>
  )
}

export default styled(Recipient)`
  .email {
    color: ${th('colors.gray')};
    font-size: ${th('fontSizes.1')}px;
    font-weight: ${th('fontWeights.regular')} !important; /* SUI override */
    margin-left: ${th('space.1')}px;
  }
`
